// allow: technical-timestamp -- in-memory assistant log timestamp
import { AiAssistantConfig, MemoryEntry } from './ai-assistant.types';

export class MemoryManager {
	private memories: MemoryEntry[] = [];

	constructor(private readonly config: AiAssistantConfig) {}

	/**
	 * Add new memory entry to the conversation history
	 * @param role - Role of the speaker (user or assistant)
	 * @param text - Text content of the message
	 */
	public commitMemory(role: 'user' | 'assistant', text: string): void {
		if (!text.trim()) {
			return; // Don't add empty memories
		}

		this.memories.push({
			role,
			text: text.trim(),
			timestamp: new Date(),
		});

		this.trimMemories();
	}

	/**
	 * Get formatted memory string for session initialization
	 * @returns Formatted memory string or empty string if no memories
	 */
	public getMemoriesForSession(): string {
		if (this.memories.length === 0) {
			return '';
		}

		const joinedMemories = this.memories.map(memory => `${memory.role}: ${memory.text}`).join('\n');

		// Trim to max length if needed
		return joinedMemories.length > this.config.maxMemoryLength
			? joinedMemories.slice(-this.config.maxMemoryLength)
			: joinedMemories;
	}

	/**
	 * Clear all memories
	 */
	public clearMemories(): void {
		this.memories = [];
	}

	/**
	 * Check if there are any memories
	 */
	public hasMemories(): boolean {
		return this.memories.length > 0;
	}

	/**
	 * Trim memories to stay within configured limits
	 */
	private trimMemories(): void {
		if (this.memories.length > this.config.maxMemoryLines) {
			this.memories = this.memories.slice(-this.config.maxMemoryLines);
		}
	}
}
